/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
import type { IntegrationOnlineMeetingResponse } from './IntegrationOnlineMeetingResponse';
export type IntegrationBookingResponse = {
    id: number;
    clientId: number;
    eventId: number;
    eventRuleId: number;
    eventCategoryId: number | null;
    status: IntegrationBookingResponse.status;
    locationSelection: IntegrationBookingResponse.locationSelection;
    isConfirmed: boolean;
    start: DateTime;
    end: DateTime;
    notice: string | null;
    onlineMeeting: IntegrationOnlineMeetingResponse | null;
};
export namespace IntegrationBookingResponse {
    export enum status {
        OPEN = 'open',
        BOOKED = 'booked',
        ASSIGNED = 'assigned',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
        REJECTED = 'rejected',
        OUTAGE = 'outage',
        SKIPPED = 'skipped',
        MOVE_REQUESTED = 'move-requested',
    }
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

